import { createRoute } from '@tanstack/react-router';
import { CUSTOMER_ROUTES } from '../constants';
import { appLayoutRoute } from '../../layout';
import { CustomersListPage, CustomerCreatePage, CustomerDetailPage, CustomerEditPage } from '../pages';

const customersListRoute = createRoute({
  path: CUSTOMER_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: CustomersListPage,
});

const customerCreateRoute = createRoute({
  path: CUSTOMER_ROUTES.CREATE,
  getParentRoute: () => appLayoutRoute,
  component: CustomerCreatePage,
});

const customerDetailRoute = createRoute({
  path: CUSTOMER_ROUTES.DETAIL,
  getParentRoute: () => appLayoutRoute,
  component: CustomerDetailPage,
});

const customerEditRoute = createRoute({
  path: CUSTOMER_ROUTES.EDIT,
  getParentRoute: () => appLayoutRoute,
  component: CustomerEditPage,
});

const customerRoutes = [
  customersListRoute,
  customerCreateRoute,
  customerDetailRoute,
  customerEditRoute,
];

export default customerRoutes;
